<template>
    <div class="screen">
        <div class="screen-loading" v-if="loading">
            <div class="loading-box">
                <van-loading  type="spinner" color="#ffffff" ></van-loading>
                <div class="loading-box-text">加载中...</div>
            </div>
        </div>
        <div class="screen-box">
            <img class="screen-center" src="../../assets/screen/m-center.png" alt="">
            <div class="screen-title">{{ oldSocketData.grabInfo.name }}</div>
        </div>
        <img class="screen-icon screen-left" src="../../assets/screen/m-left.png" alt="">
        <img class="screen-icon screen-right" src="../../assets/screen/m-right.png" alt="">
        <img class="screen-left screen-line" src="../../assets/screen/m-line_left.png" alt="">
        <img class="screen-right screen-line" src="../../assets/screen/m-line_right.png" alt="">
        <div class="screen-time">
            <div>
                <img class="screen-time-logo" src="../../assets/screen/m-screen-logo.png" alt="">
                <img class="full" @click="toggleFullScreen" v-if="flag" src="../../assets/screen/no-full.png" alt="">
                <img class="full" @click="toggleFullScreen" v-else src="../../assets/screen/full.png" alt="">
            </div>
            <div class="screen-time-tight">
                <div>·现在：{{ nowTime }}</div>
                <div>·开始：{{ startAt }} 至 结束：{{ endAt }}</div>
            </div>
        </div>
        <div class="screen-data">
            <div class="screen-data-left">
                <div class="left-top">
                    <img class="left-top-icon" src="../../assets/screen/l-total.png" alt="">
                    <span class="left-top-text">{{ totalList[2].title }}</span>
                    <img class="left-top-icon" src="../../assets/screen/l-total.png" alt="">
                </div>

                <div class="left-num">
                    <CountTo
                        :start-val="0"
                        :end="totalList[2].num"
                        :duration="3"
                        :delay="0"
                        :use-grouping="true"
                        :init="1002"
                        :decimals="0"
                    />
                </div>
                <div class="left-unit">元</div>
            </div>
            <div class="screen-data-right">
                <div class="right-box">
                    <div 
                        class="right-box-item"
                        v-for=" (item, index) in leadList"
                        :key="'lead' + index"
                    >
                        <div class="item-top">
                            <img class="item-top-img" src="../../assets/screen/screen_total.png" alt="">
                            <span class="item-top-title">{{ item.title }}</span>
                        </div>
                        <div class="item-name">{{ item.name }}</div>
                    </div>
                </div>
                <div class="right-box" style="margin-top: 29px;">
                    <div 
                        class="right-box-item"
                        v-for=" (item, index) in totalList"
                        :key="'total' + index"
                    >
                        <div class="item-top" v-if="2 != index">
                            <img class="item-top-img" src="../../assets/screen/screen-total.png" alt="">
                            <span class="item-top-title">{{ item.title }}</span>
                        </div>
                        <div class="item-name_next" v-if="2 != index">
                            <CountTo
                                :start-val="0"
                                :end="item.num"
                                :duration="3"
                                :delay="0"
                                :decimals="0"
                                :use-grouping="true"
                                :init="index + 122"
                                :pageUnit="item.unit "
                            />
                            <!-- <span>{{ item.num }}</span> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="screen-order">
            <div class="screen-order-count">
                <SeamlessScroll
                    :content="fansList"
                    v-if="fansList.length"
                    :length="5"
                    :direction="'top'"
                    :speedRate="15"
                    :refIndex="1255"
                    :mask="false"
                >
                    <template v-slot="{item}">
                        <div 
                            class="count-item"
                            v-if="item"
                        >
                            <div class="count-item-box">
                                <span>{{ item.time }}</span>
                                <span class="box-gx">恭喜</span>
                                <span>{{ item.storeName }}</span>
                            </div>
                            <div class="count-item-fans">
                                <img class="fans-ava" v-if="item.source.sourceAvatar" :src="item.source.sourceAvatar" alt="">
                                <span class="fans-name" v-if="item.source.sourceName">{{ item.source.sourceName }}</span>
                                <span class="fans-sn">{{ item.share }}</span>
                                <span v-if="item.source.sourceName && item.source.sourceAvatar" class="fans-share">{{ `消费了【 ${ item.cardNum ? item.cardName : '' } ${ item.cardNum ? '*'  : '' } ${ item.cardNum ? item.cardNum : '' } ${ item.goodsNum ? '+' : '' } ${ item.goodsNum ? item.goodsName : '' } ${ item.goodsNum ? '*'  : '' } ${ item.goodsNum ? item.goodsNum : '' }】` }}</span>
                                <span v-else class="fans-share-next">{{ `消费了【 ${ item.cardNum ? item.cardName : '' } ${ item.cardNum ? '*'  : '' } ${ item.cardNum ? item.cardNum : '' } ${ item.goodsNum ? '+' : '' } ${ item.goodsNum ? item.goodsName : '' } ${ item.goodsNum ? '*'  : '' } ${ item.goodsNum ? item.goodsNum : '' }】` }}</span>
                            </div>
                            <!--  -->
                            <span class="count-item-amount">{{ item.amount / 100 }}<span style="font-size: 5px;">元</span></span>
                        </div>
                    </template> 
                </SeamlessScroll>
            </div>
        </div>
        <div class="screen-pub">
            <div 
                class="screen-pub-boxs"
                v-for=" (b, index) in bottomList"
                :key="'bottom--_' + index"
            >
                <div class="angle_border left_top_border"></div>
                <div class="angle_border right_top_border"></div>
                <div class="angle_border left_bottom_border"></div>
                <div class="angle_border right_bottom_border"></div>
                <div class="boxs-title">{{ b.title }}</div>
                <SeamlessScroll
                    class="seamless-warp-b" 
                    :content="b.list"
                    v-if="b.list.length"
                    :length="5"
                    :direction="'top'"
                    :speedRate="15"
                    :refIndex="2251 + index"
                    :mask="false"
                >
                    <template v-slot="{item}">
                        <div 
                            class="pub-list"
                            v-if="item"
                        >
                            <div class="list-store" v-if="1 == b.type" >
                                <div class="tip-index">{{ item.index }}</div>
                                <div class="store-name" :title="item.name">{{ item.name }}</div>
                                <div class="amount-item">{{ item.totalAmount / 100 }}<span class="amount-unit">元</span></div>
                            </div>
                            <div class="list-store" v-if="2 == b.type">
                                <div class="tip-index">{{ item.index }}</div>
                                <div class="check-name" :title="item.name">{{ item.name }}</div>
                                <div class="store_name" :title=" item.vrStoreName ? item.vrStoreName : item.storeName">{{ item.vrStoreName ? item.vrStoreName : item.storeName }}</div>
                                <div class="amount-item">{{ item.totalAmount / 100 }}<span class="amount-unit">元</span></div>
                            </div>
                            <div class="list-store" v-if="3 == b.type">
                                <div class="tip-index">{{ item.index }}</div>
                                <div class="goods-name" :title="item.name">{{ item.name }}</div>
                                <span class="list-qty" v-if="3 == b.type">x <span>{{ item.totalQuantity }}</span></span>
                                <div class="amount-item">{{ item.totalAmount / 100 }}<span class="amount-unit">元</span></div>
                            </div>
                        </div>
                    </template>
                </SeamlessScroll>
            </div>
            <div class="screen-pub-boxs">
                <div class="angle_border left_top_border"></div>
                <div class="angle_border right_top_border"></div>
                <div class="angle_border left_bottom_border"></div>
                <div class="angle_border right_bottom_border"></div>
                <div class="boxs-title">单日成交榜</div>
                <div class="boxs-chart" id="myChart"></div>
            </div>
        </div>
        <PopupOeder
            v-if="popup"
            :order="popupOeders"
        />
    </div>
</template>

<script>

import SeamlessScroll from "./components/SeamlessScroll.vue";
import CountTo from "./components/count-to.vue";
import PopupOeder from "./components/popup-oeder.vue";
import { getNowTime, timestampToDatetime, timestampMountDay } from '../../utils/validate';
import getMostFrequentElement from '../../utils/getMostFrequentElement';
import mergeDateAmount from '../../utils/mergeDateAmount';
import { calculateSalesStatistics } from '../../utils/salesStatistics';
import * as echarts from 'echarts';
export default {
    // 看板数据
    name: "ScreenIndex",
    components: {
        SeamlessScroll,
        CountTo,
        PopupOeder
    },
    data() {
        return {
            scroll: true,
            loading: false,
            popup: false,
            popupOeders: [],
            chart: null,
            oldSocketData: {
                grabInfo: {
                    name: '', // 活动名称
                }
            },
            newSocketData: {},
            ws: null, //建立的连接
            lockReconnect: false, //是否真正建立连接
            timeout: 10 * 1000, //30秒一次心跳
            timeoutObj: null, //心跳心跳倒计时
            serverTimeoutObj: null, //心跳倒计时
            timeoutnum: null, //断开 重连倒计时
            isRefresh: false,
            num: 1,
            endActivity: false,
            onLine: navigator.onLine, //  navigator.onLine 获取设备是否可以上网、连接网络
            showLineStatus: false,
            nowTime: '',
            startAt: '',
            endAt: '',
            firstPlaceStore: '',
            oldOrderList: [],
            totalList: [
                { title: '总订单数', num: 0, color: '#ffffff', unit: '单', decimals: 0 },
                { title: '总产品销量', num: 0, color: '#ffffff', unit: '件', decimals: 0 },
                { title: '总成交金额', num: 0, color: '#E9AD01', unit: '元', decimals: 0 }
            ],
            leadList: [
                { title: '领先门店', name: '', l: 0 },
                { title: '领先销冠', name: '', l: 32 }
            ],
            fansList: [],
            classOption: {
                step: 0.3, // 数值越大速度滚动越快(默认1)
                limitMoveNum: 5, // 开启无缝滚动的数据量(默认5)
                hoverStop: true, // 是否开启鼠标悬停stop
                openTouch: false, // 移动端开启touch滑动
                direction: 1, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            },
            bottomList: [
                { title: '门店战力榜', list: [], type: 1 },
                { title: '店员角逐榜', list: [], type: 2 },
                { title: '产品销量榜', list: [], type: 3 },
            ],
            option: {
                tooltip: {
                    trigger: 'axis',
                    show: false,
                    backgroundColor: '#01ADF7',
                    borderColor: '#ffffff',
                    axisPointer: {
                        type: 'none'
                    },
                    formatter: function (params) {
                        let str = `<div style="text-align: left; color: #ffffff">日期：${params[0].axisValueLabel}</div><div style="text-align: left; margin-top: 6px; color: #ffffff">${params[1].seriesName + ': ' + params[1].value}<span style="font-size: 12px">元</span></div>`;
                        return str
                    },
                    position: function (point, params, dom, rect, size) {
                        var x = Math.max(0, point[0]); // 不让tooltip超出图表的左侧边界
                        var y = point[1] - 20; // 使用鼠标的y坐标
                        return [x, y]; // 返回新的 [x, y] 坐标
                    }
                },
                grid: {
                    left: '2%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                    top: '3%'
                },
                xAxis: {
                    type: 'value',
                    splitLine:{//坐标轴在grid区域的分割线
                        show: false
                    },
                    axisLabel:{
                        show: false
                    }
                },
                yAxis: [
                    {
                        type: 'category',
                        data: [],
                        inverse: true,
                        axisTick: {
                            alignWithLabel: true,
                            show: false
                        },
                        axisLine:{
                            show: false,
                            lineStyle:{ //lineStyle里面写x轴那一条线的样式
                                color: '#ffffff',
                                width: 1,    //轴线的粗细 我写的是2 最小为0，值为0的时候线隐藏
                            }
                        },
                        axisLabel:{
                            textStyle:{
                                fontSize: 8,
                                color: "#fff"
                            }
                        }
                    },
                    {
                        type: 'category',
                        show: false,
                        data: [],
                        inverse:true,
                        axisTick: {
                            alignWithLabel: true,
                            show: false
                        },
                        axisLine:{
                            show: true
                        },
                        axisLabel:{
                            textStyle:{
                                fontSize: 8,
                                color: "#fff"
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '',
                        type: 'bar',
                        yAxisIndex: 0, //使两个柱状图重合的效果
                        barWidth: '15px',
                        data: [0, 0, 0, 0, 0, 0, 0],
                        label:{
                            show: false,
                            position: 'right',
                            formatter: function(params){
                                return params.data ;
                            },
                            offset: [-10, 0]
                        },
                        itemStyle:{
                            color:"rgba(255, 255, 255, 0.3)",
                            borderColor: "#143670",
                            borderWidth: 1,
                            borderRadius:[0, 50, 50, 0],
                        },
                        emphasis:{
                            itemStyle:{
                            	borderColor: "#ffffff",	
                            }
                        }
                    },
                    {
                        name: '成交额',
                        type: 'bar',
                        yAxisIndex: 1,
                        data: [10, 52, 20, 60],
                        barWidth: '15px',
                        label:{
                            show: true,
                            position: 'right',
                            color: '#fff',
                            fontSize: 8,
                            formatter: function(params){
                                return params.data + '元';
                            },
                            offset: [0, 0]
                        },
                        // 设置每个柱子的渐变色
                        itemStyle: {
                            borderRadius:[0, 50, 50, 0],
                            color:function(params){
                            let colorList = [
                                ['#0B42A7', '#209CFF'],
                                ['#068054', '#0DB484'],
                                ['#C86A05', '#E9B500'],
                                ['#C86A05', '#E9B500'],
                            ]
                            let colorItem = colorList[params.dataIndex]
                            return new echarts.graphic.LinearGradient(0,0,1,0,
                                [
                                    {
                                        offset: 0,
                                        color: colorItem[0]
                                    },
                                    {
                                        offset: 1,
                                        color: colorItem[1]
                                    }
                                ], false)
                            }
                        }
                    },
                    
                ]
            },
            timeTimeout: null,
            flag: false,
            scaleX: 1,
            scaleY: 1,
            isFullEstate: 0,
            personnelType: 0,
            hoverVal: true,
            stepVal: 0.3,
        }
    },
    created() {
        this.loading = true;
        this.onGetNowTime()
        this.initWebpack();
        this.personnelType = this.$route.query.type;
        // 监听网络
        // 网络由异常到正常时触发
        window.addEventListener('online', this.updateOnlineStatus)
        // 网络由正常到异常触发
        window.addEventListener('offline', this.updateOfflineStatus)
    },
    methods: {
        onGetNowTime() {
            this.nowTime = getNowTime(1)
            this.timeTimeout = setTimeout(() => {
                this.onGetNowTime()
            }, 1000)
        },
        drawCharts() {
            let myChart = echarts.init(document.getElementById('myChart'));
            let option = this.option;
            myChart.setOption(option);
            this.chart = myChart;
            this.$forceUpdate()
        },
        initWebpack() {
            // const token = Cookies.get('token');
            //获取window.open跳转过来并传递过来的参数
            let qrcodeData = this.$route.query;
            const storeId = qrcodeData.storeId;
            const buyId = qrcodeData.buyId;
            const agentId = qrcodeData.agentId
            // 本地
            // const wsUrl = `ws://121.37.27.94:11002/kanban_api/v1/client?buyId=` + buyId + '&storeId=' + storeId  + '&jwt=' + token;
            // 测试
            let wsUrl = ''
            if('development' == process.env.NODE_ENV) {
                if(agentId) {
                    wsUrl = 'ws://admintest.jxt1314.com/kanban_api/v1/client?buyId=' + buyId + '&agentId=' + agentId;
                } else {
                    wsUrl = 'ws://admintest.jxt1314.com/kanban_api/v1/client?buyId=' + buyId + '&storeId=' + storeId
                }
                // if(agentId) {
                //     wsUrl = 'wss://admin.jxt1314.com/kanban_api/v1/client?buyId=' + buyId + '&agentId=' + agentId;
                // } else {
                //     wsUrl = 'wss://admin.jxt1314.com/kanban_api/v1/client?buyId=' + buyId + '&storeId=' + storeId
                // }
            } else {
                if(agentId) {
                    wsUrl = 'wss://admin.jxt1314.com/kanban_api/v1/client?buyId=' + buyId + '&agentId=' + agentId;
                } else {
                    wsUrl = 'wss://admin.jxt1314.com/kanban_api/v1/client?buyId=' + buyId + '&storeId=' + storeId
                }
            }
            this.ws = new WebSocket(wsUrl);
            // 监听socket连接
            this.ws.onopen = this.onopen;
            // 监听socket消息
            this.ws.onmessage = this.onmessage;
            this.ws.onclose = this.onclose;
            // 监听socket错误信息
            this.ws.onerror = this.onerror;
        },
        reconnect() {
            //重新连接
            var that = this;
            if (that.lockReconnect) {
                return;
            }
            ;
            that.lockReconnect = true;
            //没连接上会一直重连，设置延迟避免请求过多
            that.timeoutnum && clearTimeout(that.timeoutnum);
            that.timeoutnum = setTimeout(function () {
                //新连接
                that.initWebpack();
                that.lockReconnect = false;
            }, 5000);
        },
        reset() {
            //重置心跳
            let that = this;
            //清除时间
            clearTimeout(that.timeoutObj);
            clearTimeout(that.serverTimeoutObj);
            //重启心跳
            that.start();
        },
        start() {
            //开启心跳
            let that = this
            this.timeoutObj && clearTimeout(this.timeoutObj);
            this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
            this.timeoutObj = setTimeout(function () {
                // console.log('进来心跳')
                //这里发送一个心跳，后端收到后，返回一个心跳消息，
                if (that.ws.readyState == 1) {
                    //如果连接正常
                    that.ws.send("ping");
                    // console.log('保持心跳')
                } else {
                    //否则重连
                    that.reconnect();
                }
            }, that.timeout)
        },
        onopen() {
            this.endActivity = true;
            console.log("socket连接成功")

            // this.getNoReadRecords();
            //开启心跳
            this.start();
        },
        onmessage(e) {
            if (e && e.data) {
                if (e.data == "ping") {
                    //收到服务器信息，心跳重置
                    this.reset();
                    return;
                }
                let socketData = JSON.parse(e.data);
                const cuTimeStamp = Math.round(new Date().getTime() / 1000).toString();
                if (socketData) {
                    setTimeout(() => {
                        this.loading = false;
                        if (socketData.msgType && socketData.msgType == 2) {
                            if (this.oldSocketData) {
                                this.oldSocketData.msgType = 2;
                            }
                            this.initDataNew(socketData)
                        } else {
                            this.oldSocketData = socketData;    
                            this.oldSocketData.msgType = 1;
                            this.initData(socketData)
                        }
                    }, 2000)
                    this.reload();
                }

                // 活动结束，停止socket
                if (socketData.grabInfo && socketData.grabInfo.endAt && socketData.grabInfo.endAt < cuTimeStamp) {
                    this.closeSocket()
                }
            }
        },
        initData(socketData) {
            const type = Number(this.$route.query.type) ? Number(this.$route.query.type) : 1
            if(1 == socketData.msgType) {
                this.startAt = timestampToDatetime(socketData.grabInfo.startAt * 1000, 1);
                this.endAt = timestampToDatetime(socketData.grabInfo.endAt * 1000, 1);
            }
            this.getCountHeads(socketData.orderList)
            this.getFansList(socketData.orderList, socketData.grabInfo.openPk, socketData.grabInfo.pkType, type)
            this.getBargainInfo(socketData.orderList)
            this.getBottomList(socketData.orderList,  socketData.vrStoreTradeList.length, socketData.grabInfo.openPk, socketData.grabInfo.pkType, type)
            this.oldOrderList = socketData.orderList
            if(socketData.vrStoreTradeList.length) {
                this.getStoreTradeList(socketData.vrStoreTradeList, socketData.orderList.length)
            }
        },
        initDataNew(socketData) {
            const type = Number(this.$route.query.type) ? Number(this.$route.query.type) : 1
            this.popupOeders = socketData.orderList
            this.popup = true
            const list = socketData.orderList.concat(this.oldOrderList)
            this.oldOrderList = list
            this.getCountHeads(list)
            this.getFansList(list, this.oldSocketData.grabInfo.openPk, this.oldSocketData.grabInfo.pkType, type)
            this.getBargainInfo(list)
            this.getBottomList(list, socketData.vrStoreTradeList.length, this.oldSocketData.grabInfo.openPk, this.oldSocketData.grabInfo.pkType, type)
            if(socketData.vrStoreTradeList.length) {
                this.getStoreTradeList(socketData.vrStoreTradeList, socketData.orderList.length)
            }
            setTimeout(() => {
                this.popup = false
                this.popupOeders = []
            }, 5000);
        },
        getCountHeads(list) {
            let heads = [];
            let totalCardNum = 0;
            let totalGoodsNum = 0;
            let totalAmount = 0;
            
            if (list && list.length) {
                list.forEach(item => {
                    heads.push(item.userId);
                    totalCardNum += item.cardNum || 0;
                    totalGoodsNum += item.goodsNum || 0;
                    totalAmount += item.amount || 0;
                });
            }
            // Array.from(new Set(heads)).length;
            this.totalList[0].num = list.length
            this.totalList[1].num = totalCardNum + totalGoodsNum;
            this.totalList[2].num = totalAmount / 100;
            this.totalList[2].decimals = this.isInteger(totalAmount / 100) ? 0 : 2;
        },

        isInteger(num) {
            return num % 1 === 0;
        },

        getFirstName(list, key, index) {
            let store = []
            if (list && list.length) {
                store = list.map(item => item[key]);
            }
            this.leadList[index].name = getMostFrequentElement(store)
        },
        getFansList(list, opk, pt, type) {
            const t = 1 == opk && 1 == pt ? 1 : 0
            let fans = []
            list.forEach(item => {
                let shareStr = '';
                if(1 == type) {
                    if(item.clerkId && item.clerkName) {
                        shareStr = `${item.clerkName ? '分享' : ''}【${item.userName}】`
                    } else if(item.promoterId && item.promoterName) {
                        shareStr = `${item.promoterName ? '分享' : ''}【${item.userName}】`		
                    } else if(item.shareId && item.shareName) {
                        shareStr = `${item.shareName? '分享' : ''}【${item.userName}】`
                    } else {
                        shareStr = `【${item.userName}】`
                    }
                } else if(2 == type) {
                	shareStr = `${item.clerkName ? '分享' : ''}【${item.userName}】`
                } else if(3 == type) {
                	shareStr = `${item.promoterName ? '分享' : ''}【${item.userName}】`	
                } else if(4 == type) {
                	shareStr = `${item.shareName? '分享' : ''}【${item.userName}】`
                } 
                let sourceName = '';
                if(1 == type) {
                    sourceName = item.clerkId && item.clerkName ? item.clerkName : item.promoterId && item.promoterName ? item.promoterName : item.shareId && item.shareName ? item.shareName : ''	
                } else if(2 == type) {
                	sourceName = item.clerkName	
                } else if(3 == type) {
                	sourceName = item.promoterName	
                } else if(4 == type) {
                	sourceName = item.shareName
                }
                let sourceAvatar = '';
                if(1 == type) {
                    sourceAvatar = item.clerkId && item.clerkAvatar? item.clerkAvatar : item.promoterId && item.promoterAvatar? item.promoterAvatar : item.shareId && item.shareAvatar ? item.shareAvatar : ''
                } else if(2 == type) {
                	sourceAvatar = item.clerkAvatar	
                } else if(3 == type) {
                	sourceAvatar = item.promoterAvatar
                } else if(4 == type)   {
                	sourceAvatar = item.shareAvatar
                }
                fans.push({
                    time: timestampToDatetime(item.payAt * 1000, 2),
                    storeName: 1 == t ? item.vrStoreName : item.storeName,
                    source:{
                        sourceName: sourceName,
                        sourceAvatar: sourceAvatar
                    },
                    share: shareStr,
                    cardName: item.cardName,
                    cardNum: item.cardNum,
                    goodsName: item.goodsName,
                    goodsNum: item.goodsNum,
                    amount: item.amount,
                })
            })
            this.fansList = fans
            this.$forceUpdate()
        },
        getBargainInfo(list) {
            let b = []
            list.forEach(item => {
                b.push({
                    date: timestampMountDay(item.payAt * 1000)[0],
                    amount: item.amount,
                    year: timestampMountDay(item.payAt * 1000)[1]
                })
            })
            let dateArr = mergeDateAmount(b)
            const today = dateArr.filter(item => item.date == '今日')
            dateArr = dateArr.filter(item => item.date != '今日')
            dateArr = mergeDateAmount(dateArr)
            if(dateArr.length > 3 ) {
                dateArr = dateArr.slice(0, 3)
            }
            if (today[0] && !dateArr.some(item => item.date === today[0].date)) {
                dateArr.push(today[0])
            } else {
                dateArr.push({ date: timestampMountDay()[0], amount: 0, year: timestampMountDay()[1] })
            }
            dateArr = mergeDateAmount(dateArr)
            this.option.yAxis[0].data = dateArr.map(item => item.date)
            let yArr = []
            dateArr.forEach(item => {
                yArr.push(dateArr[0].amount / 100)
            })
            this.option.yAxis[1].data = yArr
            this.option.series[1].data = dateArr.map(item => item.amount / 100)
            const s = this.option.series[1].data
            let ls = []
            s.forEach(item => {
                ls.push(dateArr[0].amount / 100)
            })
            this.option.series[0].data = ls
            setTimeout(() => {
                this.drawCharts()
            }, 1000);
            this.$forceUpdate()
        },
        getBottomList(list, type, opk, pt, personnelType) {
            const obj = calculateSalesStatistics(list, opk, pt, personnelType)
            if(!type) {
                this.bottomList[0].list = list.length ? obj.storeSales : []
                this.leadList[0].name = list.length ? obj.storeSales[0].name : ''
            }
            const st = personnelType
            if(1 == st) {
                let ls = []
                let allSales = obj.clerkSales.concat(obj.spreaderSales).concat(obj.memberSales)
                allSales = allSales.filter(item => item.name)
                const seenPhones = new Set()
                ls = allSales.filter(item => {
                    if(!seenPhones.has(item.phone)) {
                        seenPhones.add(item.phone)
                        return true
                    }
                    return false
                })
                const tradeNo = new Set()
                ls = ls.filter(item => {
                    if(!tradeNo.has(item.tradeNo)) {
                        tradeNo.add(item.tradeNo)
                        return true
                    }
                    return false
                })
                
                ls.sort((a, b) => {
                    const aIsClerk = obj.clerkSales.includes(a)
                    const bIsClerk = obj.clerkSales.includes(b)
                    if(aIsClerk && !bIsClerk) return -1
                    if(!aIsClerk && bIsClerk) return 1
                    return b.totalAmount - a.totalAmount
                })
                ls = ls.sort((a, b) => b.totalAmount - a.totalAmount)
                ls.forEach((item, index) => {
                    item.index = (index + 1).toString().padStart(2, '0')
                })
                this.bottomList[1].list = ls
                this.bottomList[1].title = '分享角逐榜'
            } else if(2 == st) {
                let c = obj.clerkSales.filter(item => item.name)
                c = c.sort((a, b) => b.totalAmount - a.totalAmount)
                this.bottomList[1].list = c
                this.bottomList[1].title = '店员角逐榜'
            } else if(3 == st) {
                let s = obj.spreaderSales.filter(item => item.name)
                s = s.sort((a, b) => b.totalAmount - a.totalAmount)
                this.bottomList[1].list = s
                this.bottomList[1].title = '推广员角逐榜'
            } else {
                let m = obj.memberSales.filter(item => item.name)
                m = m.sort((a, b) => b.totalAmount - a.totalAmount)
                this.bottomList[1].list = m
                this.bottomList[1].title = '顾客角逐榜'
            }
            const lbs = JSON.parse(JSON.stringify(this.bottomList[1].list)) 
            const lbsArr = lbs.sort((a, b) => b.totalAmount - a.totalAmount)
            this.leadList[0].name = lbsArr.length ? lbsArr[0].name : ''
            this.bottomList[2].list = obj.goodsSales
            this.$forceUpdate()
        },
        getStoreTradeList(list, t) {
            let store = []
            list.forEach((item, index) => {
                store.push({
                    name: item.storeName,
                    totalAmount: item.amount,
                    index: (index + 1).toString().padStart(2, '0'),
                })
            })
            this.bottomList[0].list = t ? store : []
            this.leadList[0].name = t ? store[0].name : ''
        },
        reload() {
            this.isRefresh = false
            this.$nextTick(() => this.isRefresh = true)
        },
        onclose(e) {
            console.log("连接关闭", e);
            console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean);
            var msg = JSON.stringify({cmd: 'out_chatting', token: Cookies.get('token')});
            // this.ws.send(msg);
            //手动关闭，不再重连
            if (this.endActivity) {
                this.reconnect();
            }
        },
        onerror(e) {
            console.log("出现错误");
            //手动关闭，不再重连
            if (this.endActivity) {
                this.reconnect();
            }
        },
        changeTiming() {
            setInterval(() => {
                this.changeNumber()
            }, 3000)
        },
        changeNumber() {
            const total = this.turnover[1].total;
            const frameNum = 60;
            const _this = this;
            let animation = window.requestAnimationFrame(function f() {
                if (_this.amoutFrame < total) {
                    _this.amoutFrame = _this.amoutFrame + total / frameNum;
                    // 动画继续
                    animation = window.requestAnimationFrame(f);
                } else {
                    _this.amoutFrame = total;
                    // 动画停止
                    window.cancelAnimationFrame(f);
                }
                _this.turnover[1].total = _this.amoutFrame;
            });
        },
        closeSocket() {
            // 停止
            if (this.ws) {
                this.ws.close();
                this.endActivity = false;
                this.timeoutObj && clearTimeout(this.timeoutObj);
                this.timeoutnum && clearTimeout(this.timeoutnum);
                this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
            }
        },
        updateOnlineStatus() {
            this.onLine = true
            this.showLineStatus = false
            console.log('网络连接成功')
        },
        updateOfflineStatus() {
            this.onLine = false
            this.showLineStatus = true
            console.log('网络断开连接')
        },
        onCloseDialog() {
            this.showLineStatus = false
        },
        beforeDestroy() {
            this.closeSocket()
            clearTimeout(this.timeTimeout)
        },
        beforeRouteLeave() {
            this.closeSocket()
            clearTimeout(this.timeTimeout)
        },
        isFullScreen() {
            // 判断是否为 iOS 设备
            return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || (typeof window.webkitIsFullScreen !== 'undefined' && window.webkitIsFullScreen)
        },
        toggleFullScreen() {
            let element = document.documentElement

            if (!this.isFullScreen()) {
                // 如果不是全屏，则尝试进入全屏
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullscreen) { // Safari
                    element.webkitRequestFullscreen();
                } else if (element.mozRequestFullScreen) { // Firefox
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) { // IE/Edge
                    element.msRequestFullscreen();
                    
                }
                this.flag = true; //  全屏
                // this.setScale();
            } else {
            // 如果已经是全屏，则退出全屏
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) { // Safari
                    document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) { // Firefox
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) { // IE/Edge
                    document.msExitFullscreen();
                }
                this.flag = false; //  不全屏
                // this.setScale();
            }
        }
    },
    mounted() {
        // 初始化
        // this.init();
        document.getElementById('app').style.background = '#11073B'
    }
}
</script>

<style lang="scss" scoped src="./screen.scss"></style>